<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    right
    width="100%"
    height="100%"
    app
  >
    <v-card
      v-if="question && drawer"
      flat
    >
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-card-text>
          <v-row>
            <v-col>
              <v-card-title class="pt-0">
                <v-textarea
                  v-if="showQuestion"
                  v-model="question.question"
                  auto-grow
                  rows="1"
                  label="Question"
                  outlined
                  :rules="[$rules.required]"
                />
                <template v-else>
                  {{ question.question }}
                  <v-icon
                    small
                    color="primary"
                    class="ml-1"
                    @click="showQuestion = true"
                  >
                    edit
                  </v-icon>
                </template>
              </v-card-title>
              <v-card-subtitle class="py-0">
                <v-row>
                  <v-col
                    v-if="question.id"
                    cols="auto"
                  >
                    <span class="font-weight-bold">Id</span> {{ question.id }}
                  </v-col>
                </v-row>
              </v-card-subtitle>
            </v-col>
            <v-spacer class="limited-spacer" />
            <v-col
              cols="auto"
              class="my-auto"
            >
              <v-icon @click="drawer = false"> close </v-icon>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-text>
          <v-container>
            <Quill
              :id="drawer && question.id ? question.id.toString() : null"
              v-model="question.answer"
              container-id="edit-question"
              height="calc(90%)"
            />
          </v-container>
        </v-card-text>
      </v-form>
    </v-card>
    <template #append>
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          @click="save"
        >
          Save
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import Quill from '@/components/content/Quill';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
export default {
  name: 'CatalogEditQuestion',
  components: { Quill },
  data() {
    return {
      loading: false,
      valid: false,
      saving: false,
      drawer: false,
      question: {},
      showQuestion: false
    };
  },

  computed: {
    isAdd() {
      return !this.question.id;
    },
    page() {
      if (this.question.catalogContentPageId) {
        return this.catalog_page;
      }
      return null;
    },
    ...mapGetters({
      topic_name: 'lookup/topic_name',
      catalog_page: 'catalogPages/edit_catalog_page'
    })
  },

  async mounted() {
    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.EDIT_CATALOG_PAGE_QUESTION_SHOW);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.EDIT_CATALOG_PAGE_QUESTION_SHOW, (data) => {
      this.question = cloneDeep(data.question);
      this.drawer = true;
      this.saving = false;
      this.showQuestion = this.isAdd;
    });
  },

  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      this.$store
        .dispatch('content/saveCatalogQuestion', this.question)
        .then(() => {
          this.drawer = false;
          this.$emit('save');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
